import { Box, MobileStepper, Modal, Typography } from "@mui/material";
import React from "react";
import Close from "../../Components/Icons/Close";
import cssClasses from "./BookingForm.module.css";
import Button from "../../Subcomponents/Button";
import { makeStyles } from "@mui/styles";
import CustomInput from "../../Subcomponents/CustomInput";
import { useState } from "react";
import { getBankAccDetails, getPAN_cardDetails } from "../../Services/SurepassApi";
import { dismissLoader, presentLoader } from "../../Services/loader";
import DropDown from "../../Subcomponents/DropDown";
import { supabase } from "../../supabaseClient";
import { submitBookingForm, updateAllotmentPayment, updatePersonTable } from "../../Services/Booking";
import { useEffect, useRef } from "react";
import { errorTost, successTost } from "../../Services/Toast";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import debounce from "lodash.debounce";
import RightArrow from "../../Components/Icons/RightArrow";
import backArrow from "../../Assets/Images/Common/backArrow.svg";
import { addCRMLogs } from "../../Services/Agreement";
import { useSelector, useDispatch } from "react-redux";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import CryptoJS from "crypto-js";
import { sendOTPMessageToMailForKyc } from "../../Services/SmsService";

const useStyles = makeStyles((theme) => ({
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "0.7rem",
		top: "0.2rem",
	},
	stepper: {
		"& .MuiLinearProgress-root": {
			backgroundColor: "rgba(82, 108, 130, 0.1) !important",
			height: "0.8rem !important",
			borderRadius: "5rem !important",
			width: "100% !important",
			"& .MuiLinearProgress-bar": {
				backgroundColor: "#155EEF !important",
			},
		},
	},
}));

const BookingForm = ({ open, handleClose, allotment }) => {
	const classes = useStyles();
	let loggedInUser = useSelector((state) => state.Auth.user);
	const dispatch = useDispatch();
	const [totalSteps, setTotalStep] = useState(3);
	const [activeStep, setActiveStep] = useState(1);
	const [personalButtonNext, setPersonalButtonNext] = useState(false);
	const [generalButtonNext, setGeneralButtonNext] = useState(false);
	const [AddressButtonNext, setAddressButtonNext] = useState(false);
	const [bookingForm, setBookingForm] = useState({
		panNumber: "",
		firstName: "",
		lastName: "",
		middleName: "",
		email: "",
		customerBankDetails: {
			accountNo: "",
			ifscCode: "",
			accHolderName: "",
			accType: "",
			bankName: "",
		},
	});
	const [helperText, setHelperText] = useState({
		panNumber: "",
		accNumber: "",
		ifsc: "",
		bankName: "",
		accType: "",
		email: ""
	});
	const [panSuccess, setPanSuccess] = useState(false);
	const [accSuccess, setAccSuccess] = useState(false);
	const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
	const [emailLabelText, setEmailLabelText] = useState("");

	const verifiedEmail = useRef(false);
	const [otptimerEmail, setOtpTimerEmail] = useState(false);
	const [showEmailOtp, setShowEmailOtp] = useState(false);
	const [emailState, setEmailState] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});
	const [recievedEmailOtp, setRecievedEmailOtp] = useState(null);

	useEffect(() => {
		console.log(allotment);
		presentLoader();
		supabase
			.from("KycDocuments")
			.select("otherDetails->data->pan_number")
			.eq("leadId", allotment.leadId.leadId)
			.then(async (sitevisitRes) => {
				// let pin = await supabase.from("Pincodes").select("*");
				// setPincodes(
				// 	pin.data.map((m) => {
				// 		return m.pincode.toString();
				// 	})
				// );
				if (sitevisitRes.data.length > 0) {
					getPAN_cardDetails(sitevisitRes.data[0].pan_number)
						.then((resp) => {
							if (resp.data.message_code === "success") {
								setPanSuccess(true);
								if (resp.data.data.full_name.split(" ").length > 2) {
									setBookingForm((pre) => {
										pre.panNumber = sitevisitRes.data[0].pan_number;
										pre.firstName = resp.data.data.full_name.split(" ")[0];
										pre.middleName = resp.data.data.full_name.split(" ")[1];
										pre.lastName = resp.data.data.full_name.split(" ")[2];
										return { ...pre };
									});
								} else if (resp.data.data.full_name.split(" ").length === 2) {
									setBookingForm((pre) => {
										pre.panNumber = sitevisitRes.data[0].pan_number;
										pre.firstName = resp.data.data.full_name.split(" ")[0];
										pre.lastName = resp.data.data.full_name.split(" ")[1];
										return { ...pre };
									});
								} else {
									setBookingForm((pre) => {
										pre.panNumber = sitevisitRes.data[0].pan_number;
										pre.firstName = resp.data.data.full_name.split(" ")[0];
										return { ...pre };
									});
								}
								dismissLoader();
							}
						})
						.catch((err) => {
							dismissLoader();
							// setHelperText((pre) => { pre.panNumber = 'Incorrect Pan Number'; return { ...pre } })
						});
				} else {
					dismissLoader();
				}
			});
	}, []);

	useEffect(() => {
		let validation = validatePersonalDetailsForButton();
		if (validation.flag) {
			setPersonalButtonNext(true);
		} else {
			setPersonalButtonNext(false);
		}
	}, [personalButtonNext, validatePersonalDetailsForButton]);

	function closeModal() {
		setActiveStep(1);
		handleClose();
	}

	function validationPersonalDetails() {
		var form = true;
		if (bookingForm.panNumber === "") {
			form = false;
			setHelperText((pre) => {
				pre.panNumber = "Please Enter Pan Card Number";
				return { ...pre };
			});
		}
		console.log(verifiedEmail.current)
		if (bookingForm.email === '') {
			form = false;
			setHelperText((pre) => { pre.email = 'Please Enter Email'; return { ...pre } })
		}
		if (!verifiedEmail.current) {
			form = false;
			setHelperText((pre) => { pre.email = 'Please Verify Email'; return { ...pre } })
		}
		return {
			flag: form,
		};
	}

	function validatePersonalDetails() {
		let flag = validationPersonalDetails();
		if (flag.flag && helperText.panNumber === "" && helperText.email === "") {
			handleNext();
		}
	}

	function validatePersonalDetailsForButton() {
		var form = true;
		if (helperText.panNumber !== "" || bookingForm.panNumber === "") {
			form = false;
		}
		return {
			flag: form,
		};
	}

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		if (activeStep === 3) {
			// console.log("done");
		}
	};
	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
		if (activeStep === 1) {
			handleClose();
		}
	};

	function validateForm() {
		let flag = true;
		if (bookingForm.customerBankDetails.accountNo === "") {
			flag = false;
			setHelperText((pre) => {
				pre.accNumber = "Please enter bank account number";
				return { ...pre };
			});
		}
		if (bookingForm.customerBankDetails.ifscCode === "") {
			flag = false;
			setHelperText((pre) => {
				pre.ifsc = "Please enter ifsc code";
				return { ...pre };
			});
		}
		if (!bookingForm.customerBankDetails.bankName || bookingForm.customerBankDetails.bankName === "") {
			flag = false;
			setHelperText((pre) => {
				pre.bankName = "Please enter bank name";
				return { ...pre };
			});
		}
		if (bookingForm.customerBankDetails.accType === "") {
			flag = false;
			setHelperText((pre) => {
				pre.accType = "Please enter account type";
				return { ...pre };
			});
		}
		if (bookingForm.email === '') {
			flag = false
			setHelperText((pre) => { pre.email = 'Please enter email'; return { ...pre } })
		}
		return flag;
	}

	async function saveForm() {
		let flag = validateForm();
		if (flag) {
			setOpenConfirmationModal(true);
		}
	}

	function ModalResp(e) {
		if (e === "confirmed") {
			presentLoader();
			const payload = {
				...bookingForm,
				// aadharNumber: Number(bookingForm?.aadharNumber),
				aadharNumber: bookingForm?.aadharNumber && bookingForm?.aadharNumber !== ''
          			? Number(bookingForm?.aadharNumber)
          			: null,
				contactNumber: Number(bookingForm?.contactNumber),
				pincode: Number(bookingForm?.pincode),
				// cityId: bookingForm?.cityId !== "" ? bookingForm?.cityId : null,
				cityId: bookingForm?.cityId && bookingForm?.cityId !== "" ? Number(bookingForm?.cityId) : null,
			};
			submitBookingForm(payload).then((formRes) => {
				updatePersonTable(bookingForm.firstName + " " + bookingForm.middleName + " " + bookingForm.lastName, loggedInUser?.personId?.personId)
					.then((resp) => {
				updateAllotmentPayment({ kycFormFilled: true, bookingFormId: formRes[0].bookingFormId }, allotment.allotmentPaymentId).then(
					async (updateRes) => {
						// dismissLoader();
						// handleClose()
						// successTost("Form Submitted Successfully")

						if (allotment.paidAmount >= allotment?.bookingAmt.total) {
							if (allotment.status === "Payment Complete") {
								let statusRes = await supabase.from("InventoryStatus").select("inventoryStatusId").eq("status", "Kyc Done");
								if (allotment.unitId) {
									await supabase
										.from("Inventory")
										.update({
											inventoryStatusId: statusRes.data[0].inventoryStatusId,
										})
										.eq("unitId", allotment.unitId.unitId);
								} else {
									await supabase
										.from("Inventory")
										.update({
											inventoryStatusId: statusRes.data[0].inventoryStatusId,
										})
										.eq("unitId", allotment.inventoryMergedId.unit1Id.unitId);
									await supabase
										.from("Inventory")
										.update({
											inventoryStatusId: statusRes.data[0].inventoryStatusId,
										})
										.eq("unitId", allotment.inventoryMergedId.unit2Id.unitId);
								}
								let obj = {
									allotmentPaymentId: allotment?.allotmentPaymentId,
									crmStatus: "KYC Form Completed",
									message: "KYC Form is filled by customer",
								};
								addCRMLogs(obj)
									.then((leadLog) => {
										console.log(leadLog);
									})
									.catch((err) => {
										console.log("CRMlog", err);
									});
								dismissLoader();
								handleClose();
								successTost("Form Submitted Successfully");
								// axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}bookings/send-welcome-email`, { allotmentPaymentId: allotment.allotmentPaymentId }).then((reqRes) => {
								// })
							}
						} else {
							let obj = {
								allotmentPaymentId: allotment?.allotmentPaymentId,
								crmStatus: "KYC Form Completed",
								message: "KYC Form is filled by customer",
							};
							addCRMLogs(obj)
								.then((leadLog) => {
									console.log(leadLog);
								})
								.catch((err) => {
									console.log("CRMlog", err);
								});
							dismissLoader();
							handleClose();
							successTost("Form Submitted Successfully");
						}
					}
				);
					})
					.catch((err) => {
						console.log(err);
						errorTost(err.message);
					});
			});
		}
	}

  const handleAccNoChange = useRef(
    debounce((e) => {
      setAccSuccess(false);
      if (e === "") {
        setHelperText((pre) => {
          pre.accNumber = "Please enter bank account number";
          return { ...pre };
        });
      } else {
        if (e.length > 0) {
          if (
            bookingForm.customerBankDetails.ifscCode &&
            bookingForm.customerBankDetails.ifscCode !== ""
          ) {
            presentLoader();
            let bankObj = {
              accountNo: e,
              ifscCode: bookingForm.customerBankDetails.ifscCode,
            };
            getBankAccDetails(bankObj)
              .then((resp) => {
                if (resp.data.message_code === "success") {
                  setAccSuccess(true);
                  setBookingForm((pre) => {
                    resp.data.data.full_name = resp.data.data.full_name.trim();
                    pre.customerBankDetails.accHolderName =
                      resp.data.data.full_name;
                    return { ...pre };
                  });
                  setHelperText((pre) => {
                    pre.accNumber = "";
                    pre.ifsc = "";
                    return { ...pre };
                  });
                  dismissLoader();
                  // setHelperText((pre) => {
                  //     pre.ifsc = ''
                  //     return { ...pre }
                  // })
                }
              })
              .catch((err) => {
                dismissLoader();
                setHelperText((pre) => {
                  pre.accNumber = "Incorrect bank account number";
                  return { ...pre };
                });
              });
            // dismissLoader()
            // setHelperText((pre) => {
            //     pre.accNumber = ''
            //     pre.ifsc = ''
            //     return { ...pre }
            // })
            // setBookingForm((pre) => {
            //     // resp.data.data.full_name = resp.data.data.full_name.trim()
            //     pre.customerBankDetails.accHolderName = pre.firstName
            //     return { ...pre }
            // })
          } else {
            setHelperText((pre) => {
              pre.accNumber = "";
              return { ...pre };
            });
          }
        } else {
          setHelperText((pre) => {
            pre.accNumber = "Please enter bank account number";
            return { ...pre };
          });
        }
      }
    }, 2000)
  ).current;

	const inputfocus = (elmnt) => {
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			// const next = elmnt.target.tabIndex - 2;
			// if (next > -1) {
			// 	// elmnt.target.form.elements[next].focus();
			// 	if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			// }
		} else {
			// const next = elmnt.target.tabIndex + 1;
			const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
			if (next < 5) {
				// elmnt.target.form.elements[next].focus();
				if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			}
		}
	};

	function optEmailChange(value1, event) {
		event.preventDefault();
		if (event.target.value.length <= 1) {
			setEmailState((pre) => {
				pre[value1] = event.target.value;
				return Object.assign({}, pre);
			});
		}
	}
	const checkEmailExists = debounce(async (e) => {
		setHelperText((pre) => {
			pre.email = ""
			return { ...pre }
		})
		setEmailLabelText("Send Otp");
	}, 900);

	function sendOtpToVerifyEmail() {
		setHelperText((pre) => {
			pre.email = ""
			return { ...pre }
		})
		setEmailLabelText("");
		let body = {
			email: bookingForm.email,
		};
		sendOTPMessageToMailForKyc(body)
			.then((resp) => {
				if (resp.data.success) {
					var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
					var originalText = bytes.toString(CryptoJS.enc.Utf8);
					// console.log("Email Registration OTP", parseInt(originalText));
					setRecievedEmailOtp(parseInt(originalText));
					// 900000 ;15 min
					const myTimeout = setTimeout(smsTimeOutForEmailVerify, 900000);
					setShowEmailOtp(true);
					setOtpTimerEmail(true);
				} else {
					console.log(resp);
					if (resp?.data?.error?.ErrorMessage) {
						errorTost(resp?.data?.error?.ErrorMessage);
					} else if (resp?.data?.err?.response?.text) {
						const errText = JSON.parse(resp?.data?.err?.response?.text);
						if (errText.message && errText.message.includes("email is not valid")) {

							setHelperText((pre) => {
								pre.email = "Please Enter Valid Email"
								return { ...pre }
							})
							setEmailLabelText("");
						} else {
							setHelperText((pre) => {
								pre.email = errText.message
								return { ...pre }
							})
							setEmailLabelText("");
						}
					} else {
						setHelperText((pre) => {
							pre.email = "Something went wrong"
							return { ...pre }
						})
						setEmailLabelText("");
					}
				}
			})
			.catch((err) => {
				console.log(err);
				setEmailLabelText("");
			});
	}

	function smsTimeOutForEmailVerify() {
		if (verifiedEmail === false) {
			setHelperText((pre) => {
				pre.email = "Otp has expired.Please resend otp"
				return { ...pre }
			})
			setEmailLabelText("Resend Otp");
			setOtpTimerEmail(false);
			// setVerifiedEmail(false);
			verifiedEmail.current = false;
		} else {
			setShowEmailOtp(true);
			setOtpTimerEmail(true);
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			setRecievedEmailOtp(null);
		}
	}

	function submitEmailOtp() {
		let finalValue = emailState.otp1 + emailState.otp2 + emailState.otp3 + emailState.otp4;
		console.log(finalValue, "recievedEmailOtp", recievedEmailOtp);
		if (finalValue == recievedEmailOtp) {
			verifiedEmail.current = true;
			setShowEmailOtp(false);
			setOtpTimerEmail(false);
			setEmailLabelText("");
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			setHelperText((pre) => {
				pre.email = ""
				return { ...pre }
			})
		} else {
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			errorTost("OTP doesnt match.Please enter valid otp");
		}
	}

	return (
		<>
			<Modal
				open={open}
				onClose={(_, reason) => {
					if (reason !== "backdropClick") {
						closeModal();
					}
				}}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={[
					{
						".MuiBackdrop-root": {
							background: "rgba(52, 64, 84, 0.7)",
						},
					},
				]}
				disableAutoFocus={true}
			>
				<Box>
					<Box className={cssClasses.modalWrapper}>
						<div className={cssClasses.wrapperContent}>
							<div className={cssClasses.wrapperHeader}>
								<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
									<Close width={"1.2rem"} height={"1.2rem"} />
								</span>
								<div>Allotment Details</div>
								{activeStep !== 1 && (
									<img className={cssClasses.backArrow} src={backArrow} onClick={handleBack} alt={"backArrow"} tabIndex="0"></img>
								)}
							</div>
							<div className={cssClasses.wrapperStepper}>
								<MobileStepper
									variant="progress"
									steps={totalSteps}
									position="static"
									activeStep={activeStep}
									className={classes.stepper}
									sx={{
										maxWidth: "100%",
										// maxWidth:600,
										flexGrow: 1,
										margin: "0 auto",
										background: "#ffff ",
									}}
								/>
							</div>
							<div className={cssClasses.label}>{totalSteps - activeStep - 1} Steps to fill kyc Form</div>
							{activeStep === 1 && (
								<div className={cssClasses.wrapperContactDeatils}>
									<div className={cssClasses.addHeightToMiddleContent}>
										<div>
											<CustomInput
												style={{ textTransform: "uppercase" }}
												handleChange={(e) => {
													setPanSuccess(false);
													setBookingForm((pre) => {
														pre.firstName = "";
														pre.middleName = "";
														pre.lastName = "";
														pre.panNumber = e;
														if (e === "") {
															setHelperText((pre) => {
																pre.panNumber = "Please enter pan card number";
																return { ...pre };
															});
														} else {
															if (e.length === 10) {
																setHelperText((pre) => {
																	pre.panNumber = "";
																	return { ...pre };
																});
																presentLoader();
																getPAN_cardDetails(e)
																	.then((resp) => {
																		if (resp.data.message_code === "success") {
																			setPanSuccess(true);
																			setBookingForm((pre) => {
																				resp.data.data.full_name = resp.data.data.full_name.trim();
																				if (resp.data.data.full_name.split(" ").length > 2) {
																					pre.firstName = resp.data.data.full_name.split(" ")[0];
																					pre.middleName = resp.data.data.full_name.split(" ")[1];
																					pre.lastName = resp.data.data.full_name.split(" ")[2];
																					return { ...pre };
																				} else {
																					pre.firstName = resp.data.data.full_name.split(" ")[0];
																					// pre.middleName = resp.data.data.full_name.split(' ')[1]
																					pre.lastName = resp.data.data.full_name.split(" ")[1];
																					return { ...pre };
																				}
																			});
																			dismissLoader();
																			// setHelperText((pre) => {
																			//     pre.panNumber = ''
																			//     return { ...pre }
																			// })
																		}
																	})
																	.catch((err) => {
																		dismissLoader();
																		setHelperText((pre) => {
																			pre.panNumber = "Incorrect Pan Number";
																			return { ...pre };
																		});
																	});
															} else {
																setHelperText((pre) => {
																	pre.panNumber = "Pan number should be 10 digits";
																	return { ...pre };
																});
															}
														}
														return { ...pre };
													});
												}}
												greenTick={panSuccess}
												placeholder={"Pan Card Number"}
												label={"Pan Card Number"}
												inputType={"text"}
												mandatory={true}
												helperText={helperText.panNumber}
												value={bookingForm.panNumber}
											/>
										</div>
										<div>
											<CustomInput
												placeholder={"First Name"}
												label={"First Name"}
												inputType={"text"}
												mandatory={true}
												disabled={true}
												value={bookingForm.firstName}
											/>
										</div>
										<div>
											<CustomInput
												placeholder={"Middle Name"}
												label={"Middle Name"}
												inputType={"text"}
												mandatory={false}
												disabled={true}
												value={bookingForm.middleName}
											/>
										</div>
										<div>
											<CustomInput
												placeholder={"Last Name"}
												label={"Last Name"}
												inputType={"text"}
												mandatory={true}
												disabled={true}
												value={bookingForm.lastName}
											/>
										</div>
										<div>
											<div className={cssClasses.blockLabel}>
												Email <span style={{ color: "red" }}> *</span><div style={{ fontWeight: "bold" }}>(You will receive updates regarding your booking on this email ID.)</div>
											</div>
											<CustomInput
												clicked={(e) => {
													if (e === "Send Otp") {
														sendOtpToVerifyEmail(e);
													} else if (e === "Resend Otp") {
														sendOtpToVerifyEmail(e);
													}
												}}
												handleChange={(newValue) => {
													setEmailLabelText("");
													newValue = newValue.trimStart();
													const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
													verifiedEmail.current = false;
													if (!newValue.trim()) {
														setEmailLabelText("");

														setHelperText((pre) => {
															pre.email = "Please Enter Email"
															return { ...pre }
														})
													} else if (!newValue.match(emailIDCond)) {
														setEmailLabelText("");
														setHelperText((pre) => {
															pre.email = "Please Enter Email in Proper Format"
															return { ...pre }
														})
													} else {
														setEmailLabelText("");
														setHelperText((pre) => {
															pre.email = "Verifying..."
															return { ...pre }
														})

														if (newValue !== "") {
															checkEmailExists(newValue);
														} else if (newValue === "") {
															setEmailLabelText("");
														}
													}
													if (newValue.length <= 100) {
														setBookingForm((pre) => {
															pre.email = newValue.replaceAll(' ', '');
															return { ...pre }
														})
													}
												}}
												placeholder={"Email"}
												// label={"Email"}
												inputType={"label"}
												position={"end"}
												greenTick={verifiedEmail.current === true}
												labelText={emailLabelText}
												// mandatory={true}
												helperText={helperText.email}
												value={bookingForm?.email}
											// style={{
											// 	// background: "#FCFCFD",
											// 	borderRadius: "0.8rem",
											// 	border: "1px solid  #D0D5DD",
											// 	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
											// }}
											/>
											{otptimerEmail && (
												<div className={cssClasses.resendOtp}>
													{" "}
													Resend Otp in{" "}
													<CountdownTimer
														startFrom={180}
														onComplete={() => {
															setEmailLabelText("Resend Otp");
															setOtpTimerEmail(false);
															setRecievedEmailOtp(null);
														}}
														timeFormatter={(time) => {
															return (
																<span>
																	{`0${Math.floor(time / 60)}`.slice(-2)}:
																	{`0${time % 60}`.slice(-2)}
																</span>
															);
														}}
													/>
												</div>
											)}
											{showEmailOtp && (
												<div className={cssClasses.otpContainer}>
													<input
														className={cssClasses.otpInput}
														name="otp1"
														type="number"
														autoComplete="off"
														value={emailState.otp1}
														onChange={(e) => optEmailChange("otp1", e)}
														tabIndex="1"
														maxLength="1"
														onKeyUp={(e) => inputfocus(e)}
														id="opt-0"
														inputMode="numeric"
														pattern="[0-9]*"
													/>
													<input
														name="otp2"
														type="number"
														autoComplete="off"
														className={cssClasses.otpInput}
														value={emailState.otp2}
														onChange={(e) => optEmailChange("otp2", e)}
														tabIndex="2"
														maxLength="1"
														onKeyUp={(e) => inputfocus(e)}
														id="opt-1"
														inputMode="numeric"
														pattern="[0-9]*"
													/>
													<input
														name="otp3"
														type="number"
														autoComplete="off"
														className={cssClasses.otpInput}
														value={emailState.otp3}
														onChange={(e) => optEmailChange("otp3", e)}
														tabIndex="3"
														maxLength="1"
														onKeyUp={(e) => inputfocus(e)}
														id="opt-2"
														inputMode="numeric"
														pattern="[0-9]*"
													/>
													<input
														name="otp4"
														type="number"
														autoComplete="off"
														className={cssClasses.otpInput}
														value={emailState.otp4}
														onChange={(e) => optEmailChange("otp4", e)}
														tabIndex="4"
														maxLength="1"
														onKeyUp={(e) => inputfocus(e)}
														id="opt-3"
														inputMode="numeric"
														pattern="[0-9]*"
													/>
													<div>
														<Button
															tabIndex={5}
															style={{
																color: "#ffffff",
																backgroundColor: "#155EEF",
																fontSize: "1.4rem",
																lineHeight: "2rem",
															}}
															btnName={"Submit OTP"}
															clicked={submitEmailOtp}
														/>
													</div>
												</div>
											)}
										</div>
									</div>
									<div className={cssClasses.wrapperFooter}>
										{personalButtonNext ? (
											<Button
												style={{
													color: "#ffffff",
													backgroundColor: "#155EEF",
												}}
												btnName={"Proceed"}
												clicked={validatePersonalDetails}
												btnIcon={<RightArrow />}
												iconPosition={"right"}
											/>
										) : (
											<Button
												style={{
													color: "#155EEF",
													border: "1px solid #155EEF",
													backgroundColor: "#ffffff",
												}}
												clicked={validatePersonalDetails}
												btnName={"Proceed"}
												btnIcon={<RightArrow />}
												iconPosition={"right"}
											/>
										)}
									</div>
								</div>
							)}
							{activeStep === 2 && (
								<div className={cssClasses.wrapperContactDeatils}>
									<div className={cssClasses.addHeightToMiddleContent}>
										<div>
											<CustomInput
												// style={{ textTransform: 'uppercase' }}
												handleChange={(e) => {
													setBookingForm((pre) => {
														pre.customerBankDetails.accHolderName = "";
														pre.customerBankDetails.accountNo = e;
														return { ...pre };
													});
													handleAccNoChange(e);
												}}
												greenTick={accSuccess}
												placeholder={"Bank Account Number"}
												label={"Bank Account Number"}
												inputType={"number"}
												mandatory={true}
												helperText={helperText.accNumber}
												value={bookingForm.customerBankDetails.accountNo}
											/>
										</div>

										<div>
											<CustomInput
												style={{ textTransform: "uppercase" }}
												handleChange={(e) => {
													setAccSuccess(false);
													setBookingForm((pre) => {
														pre.customerBankDetails.accHolderName = "";
														pre.customerBankDetails.ifscCode = e;
														if (e === "") {
															setHelperText((pre) => {
																pre.ifsc = "Please enter ifsc code";
																return { ...pre };
															});
														} else {
															if (e.length === 11) {
																if (pre.customerBankDetails.accountNo && pre.customerBankDetails.accountNo !== "") {
																	presentLoader();
																	let bankObj = {
																		accountNo: pre.customerBankDetails.accountNo,
																		ifscCode: e,
																	};
																	getBankAccDetails(bankObj)
																		.then((resp) => {
																			console.log(resp);
																			if (resp.data.message_code === "success") {
																				setAccSuccess(true);
																				setBookingForm((pre) => {
																					resp.data.data.full_name = resp.data.data.full_name.trim();
																					pre.customerBankDetails.accHolderName = resp.data.data.full_name;
																					return { ...pre };
																				});
																				setHelperText((pre) => {
																					pre.accNumber = "";
																					pre.ifsc = "";
																					return { ...pre };
																				});
																				dismissLoader();
																				// setHelperText((pre) => {
																				//     pre.ifsc = ''
																				//     return { ...pre }
																				// })
																			}
																		})
																		.catch((err) => {
																			dismissLoader();
																			setHelperText((pre) => {
																				pre.ifsc = err?.response?.data?.data?.remarks;
																				return { ...pre };
																			});
																		});
																	// dismissLoader();
																	// setHelperText((pre) => {
																	// 	pre.ifsc = "";
																	// 	return { ...pre };
																	// });
																	// setBookingForm((pre) => {
																	// 	// resp.data.data.full_name = resp.data.data.full_name.trim()
																	// 	pre.customerBankDetails.accHolderName = pre.firstName;
																	// 	return { ...pre };
																	// });
																} else {
																	setHelperText((pre) => {
																		pre.ifsc = "";
																		return { ...pre };
																	});
																}
															} else {
																setHelperText((pre) => {
																	pre.ifsc = "ifsc code should be 11 digits";
																	return { ...pre };
																});
															}
														}
														return { ...pre };
													});
												}}
												greenTick={accSuccess}
												placeholder={"Bank Ifsc Code"}
												label={"Bank Ifsc Code"}
												inputType={"text"}
												mandatory={true}
												helperText={helperText.ifsc}
												value={bookingForm.customerBankDetails.ifscCode}
											/>
										</div>

										<div>
											<CustomInput
												placeholder={"Account Holder Name"}
												label={"Account Holder Name"}
												inputType={"text"}
												mandatory={true}
												disabled={true}
												value={bookingForm.customerBankDetails.accHolderName}
											/>
										</div>

										<div>
											<CustomInput
												handleChange={(e) => {
													setBookingForm((pre) => {
														if (e === "") {
															setHelperText((pre) => {
																pre.bankName = "Please enter bank name";
																return { ...pre };
															});
														} else {
															setHelperText((pre) => {
																pre.bankName = "";
																return { ...pre };
															});
														}
														pre.customerBankDetails.bankName = e;
														return { ...pre };
													});
												}}
												placeholder={"Bank Name"}
												label={"Bank Name"}
												inputType={"text"}
												mandatory={true}
												helperText={helperText.bankName}
												value={bookingForm.customerBankDetails.bankName}
											/>
										</div>

										<div>
											<DropDown
												list={["Savings", "Current"]}
												label={"Account Type"}
												placeHolder={"Account Type"}
												mandatory={true}
												selectedValue={
													bookingForm.customerBankDetails.accType === ""
														? ""
														: bookingForm.customerBankDetails.accType === "SB"
														? "Savings"
														: "Current"
												}
												helperText={helperText.accType}
												onChangeSelect={(e) => {
													setBookingForm((pre) => {
														pre.customerBankDetails.accType = e === "Savings" ? "SB" : "CB";
														return { ...pre };
													});
													setHelperText((pre) => {
														pre.accType = "";
														return { ...pre };
													});
												}}
											/>
										</div>
									</div>
									<div className={cssClasses.wrapperFooter}>
										<Button
											style={{
												color: "#ffffff",
												backgroundColor: "#155EEF",
											}}
											disable={
												Object.keys(helperText).filter((e) => {
													return helperText[e] !== "";
												}).length > 0
													? true
													: false
											}
											btnName={"Submit"}
											clicked={() => {
												saveForm();
											}}
										/>
									</div>
								</div>
							)}
						</div>
					</Box>
				</Box>
			</Modal>
			<>
				{openConfirmationModal && (
					<ConfirmationAlert
						close={() => {
							setOpenConfirmationModal(false);
							// handleClose();
						}}
						open={openConfirmationModal}
						buttonTitle={"Cancel"}
						returnRespButton={"Continue"}
						title={"Warning"}
						subTitle={"Name entered will be used for further process! Are you sure you want to continue with PAN Name " + bookingForm.firstName + " " + bookingForm.middleName + " " + bookingForm.lastName + "?"}
						confirm={(e) => {
							ModalResp(e);
						}}
					/>
				)}
			</>
		</>
	);
};

export default BookingForm;
